export const getGroupedRow = (groupRowProperties, tableRows) => {
    return {
        ...groupRowProperties,
        rows: tableRows,
    }
};

export const getRow = (rowProperties, cells) => {
    return {
        ...rowProperties,
        cells: cells,
    }
};
